import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '_atoms';
import { CreatePromotionRequestButton } from '_molecules';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { ReactComponent as EmptyImg } from 'dist/emptyStates/stepsNoCandidates.svg';
import './style.scss';

interface PromotionRequestsEmptyProps {
  jobId: string;
}

export const PromotionRequestsEmpty: React.FC<PromotionRequestsEmptyProps> = ({ jobId }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <div className="job-promotion-requests__empty">
        <EmptyImg className="empty-image" />
        <Typography.Title3 weight={TYPOGRAPHY_WEIGHT.BOLD} className="job-promotion-requests__empty-title">
          {t('translation:job_promotion_requests_tab.empty_title')}
        </Typography.Title3>
        <Typography.Text className="job-promotion-requests__empty-subtitle">
          {t('translation:job_promotion_requests_tab.empty_subtitle')}
        </Typography.Text>
        <CreatePromotionRequestButton jobId={jobId} />
      </div>
    </Card>
  );
};
